
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"146","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h146v64H0z"}}),_c('path',{attrs:{"d":"M69.24 16.578H41.973a.201.201 0 00-.203.2v7.306c0 .11.091.2.203.2h9.236c.112 0 .202.09.202.2V47.21c0 .11.09.2.203.2h7.984c.112 0 .203-.09.203-.2V24.484c0-.11.09-.2.202-.2h9.239c.111 0 .202-.09.202-.2v-7.306c0-.11-.09-.2-.202-.2zM37.284 16.731a.202.202 0 00-.197-.153h-8.51a.2.2 0 00-.196.247l7.484 30.431c.022.09.104.153.197.153h8.507a.2.2 0 00.197-.247L37.284 16.73zM28.404 31.996h-8.51a.202.202 0 00-.196.153l-3.692 15.013a.2.2 0 00.197.247h8.51a.202.202 0 00.196-.153l3.692-15.012a.2.2 0 00-.197-.248zM117.423 16.578h-8.51a.203.203 0 00-.197.153l-7.482 30.43a.2.2 0 00.197.248h8.51a.2.2 0 00.196-.153l7.482-30.43a.2.2 0 00-.196-.248zM129.994 47.162l-3.691-15.013a.202.202 0 00-.197-.153h-8.507a.2.2 0 00-.197.248l3.692 15.012c.022.09.103.153.197.153h8.507a.2.2 0 00.196-.247zM92.22 38.3a9.065 9.065 0 01-6.37 2.607 9.068 9.068 0 01-6.372-2.607 8.85 8.85 0 01-2.64-6.293 8.812 8.812 0 01.682-3.41 8.9 8.9 0 011.953-2.893 9.018 9.018 0 012.925-1.932 9.108 9.108 0 016.902 0 9.017 9.017 0 012.925 1.932c.837.828 1.5 1.811 1.952 2.892A8.847 8.847 0 0192.22 38.3zm5.086-17.612A16.304 16.304 0 0085.85 16c-2.129 0-4.236.413-6.202 1.218a16.223 16.223 0 00-5.257 3.47 16.005 16.005 0 00-3.513 5.193 15.839 15.839 0 00-1.234 6.126 15.91 15.91 0 004.752 11.31A16.304 16.304 0 0085.85 48c4.294 0 8.413-1.685 11.451-4.684a15.908 15.908 0 004.75-11.31c0-4.245-1.707-8.316-4.745-11.318z","fill":"#ED1B2F"}})])
          )
        }
      }
    